import { createApi } from "../lib/auth";
import { envConfig } from "../config";

export type { AuthData } from "../lib/auth/authTypes";

export const { API, setAuthData, clearAuthData } = createApi({
  loginUrl: "/api/1/auth/token",
  refreshTokenUrl: "/api/1/auth/token/refresh",
  baseUrl: envConfig.coreApiBaseUrl ?? undefined,
  withCredentials: true,
});
